module.exports = __webpack_public_path__ + "static/media/bigbuddah2.524b413d.jpg";